module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione3.7ddac622.svg";